export default {
  title: "",
  subtitle: "API Availability and Status Codes",
  path: "api_availability_and_status_codes",
  paragraphs: [
    "Our API is designed to operate 24/7, consistently responding with the following HTTP status codes:",
    "200 OK – Successful requests",
    "201 Created – Resource creation or successful updates",
    "For common customer errors, the API may return:",
    "400 - Bad Request",
    "401 - Unauthorized",
    "403 - Forbidden",
    "404 - Not Found",
    "422 - Unprocessable Entity",
    "If a 500 Internal Server Error occurs, please contact FacilitaPay support as soon as possible. Include the following information to help us resolve the issue quickly:",
    "The API route used, The request payload (if available), The reason for this request or business context, Screenshots, if possible, The exact time the error occurred (including timezone)",
    "This information helps our team diagnose and fix the issue efficiently."
  ],
  request:  {}
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/ApiAvailabilityStatusCode.js